import axios from 'axios';

const API_BASE_URL = 'https://meusservicospro.com.br/api';

export const uploadToServer = async (file, folder = 'apps') => {
  try {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('folder', folder);

    const response = await axios.post(`${API_BASE_URL}/upload.php`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        console.log(`Upload progress: ${percentCompleted}%`);
      },
    });

    // Ajuste para a estrutura de resposta do PHP
    if (response.data.success) {
      return response.data.data.fileUrl;
    } else {
      throw new Error(response.data.message || 'Falha no upload');
    }
  } catch (error) {
    console.error('Erro no upload:', error);
    
    // Mensagem de erro mais específica
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    } else if (error.message) {
      throw new Error(error.message);
    } else {
      throw new Error('Falha no upload da imagem. Verifique a conexão.');
    }
  }
};

export const deleteFromServer = async (fileUrl) => {
  try {
    console.log('Arquivo para deletar:', fileUrl);
    return true;
  } catch (error) {
    console.error('Erro ao deletar arquivo:', error);
    throw error;
  }
};